import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: i18n.t('NAME_KEY'),
    stateKey: 'name',
  },
  {
    gridXs: 12,
    label: i18n.t('DESCRIPTION_KEY'),
    stateKey: 'description',
  },
  {
    gridXs: 12,
    label: 'Template',
    stateKey: 'from_template',
    isSelect: true,
    options: [
      { value: 'superadmin', label: i18n.t('ROLES.SUPERADMIN_KEY') },
      { value: 'admin', label: i18n.t('ROLES.ADMIN_KEY') },
      { value: 'operator', label: i18n.t('ROLES.OPERATOR_KEY') },
      { value: 'client_operator', label: i18n.t('ROLES.CLIENT_OPERATOR_KEY') },
    ],
  },
  {
    gridXs: 6,
    label: `${i18n.t('ACTIVATED_KEY')}?`,
    stateKey: 'active',
    fontSize: '12px',
    isRadioGroup: true,
    radioGroupOptions: [
      { value: true, label: i18n.t('YES_KEY') },
      { value: false, label: i18n.t('NO_KEY') },
    ],
  },
  {
    gridXs: 6,
    label: `${i18n.t('RESTRICTED_OPERATORS_KEY')}?`,
    stateKey: 'restricted_operators',
    fontSize: '12px',
    isRadioGroup: true,
    radioGroupOptions: [
      { value: true, label: i18n.t('YES_KEY') },
      { value: false, label: i18n.t('NO_KEY') },
    ],
  },
];

export default fields;
